namespace GeniuzPOS.AdvPromo {
    export interface Report_Adv02Row {
        PromoCampaign?: string;
        PmGroupId?: string;
        PmId?: string;
        PluCode?: string;
        PluShortDesc?: string;
        FullName?: string;
        SalesQty?: number;
        SalesAmtBeforePromo?: number;
        PromoDisc?: number;
        SalesAmtAfterPromo?: number;
    }

    export namespace Report_Adv02Row {
        export const idProperty = 'PromoCampaign';
        export const nameProperty = 'PromoCampaign';
        export const localTextPrefix = 'AdvPromo.Report_Adv02';
        export const deletePermission = '4ADVANCED_PROMOTION:รายงาน:ยอดขายโปรโมชั่น:View';
        export const insertPermission = '4ADVANCED_PROMOTION:รายงาน:ยอดขายโปรโมชั่น:View';
        export const readPermission = '4ADVANCED_PROMOTION:รายงาน:ยอดขายโปรโมชั่น:View';
        export const updatePermission = '4ADVANCED_PROMOTION:รายงาน:ยอดขายโปรโมชั่น:View';

        export declare const enum Fields {
            PromoCampaign = "PromoCampaign",
            PmGroupId = "PmGroupId",
            PmId = "PmId",
            PluCode = "PluCode",
            PluShortDesc = "PluShortDesc",
            FullName = "FullName",
            SalesQty = "SalesQty",
            SalesAmtBeforePromo = "SalesAmtBeforePromo",
            PromoDisc = "PromoDisc",
            SalesAmtAfterPromo = "SalesAmtAfterPromo"
        }
    }
}
